



































































































































































































































































































































import { Vue } from 'vue-property-decorator'
import {urlHelper} from '../../util/UrlHelper'

export default Vue.extend({
  name: 'App',
  data: () => ({
    urls: {
      claims: urlHelper.getApplicationUrl('claims'),
      contractLookup: urlHelper.getApplicationUrl('contractlookup')
    }
  })
})
